import React, { useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { selectAuth, setAuth } from '../../redux/infoSlice';
import { isAccessTokenExpired, readStoredAuth } from '../../utils/authStorage';

export * from './signIn';
export * from './signUp';
export * from './resetPassword';
export * from './terms';
export * from './language';
export * from './organizationSearch';
export * from './organizationSearchDetail';
export * from './organizationApply';

export const Auth = ({ children }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const authInfo = useSelector(selectAuth);

    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('accessToken') : null;
    const isExpired = token ? isAccessTokenExpired(token) : false;

    useEffect(() => {
        if (!token) return;
        if (isExpired) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('meInfo');
            localStorage.removeItem('userListFilterType');
            localStorage.removeItem('userListSearchName');
            dispatch(setAuth({ accessToken: null, refreshToken: null }));
            return;
        }
        if (!authInfo.isLoggedIn) {
            dispatch(setAuth(readStoredAuth()));
        }
    }, [token, isExpired, authInfo.isLoggedIn, dispatch]);

    if (!token || isExpired) {
        return <Navigate to="/auth/signin" replace />;
    }

    return <>{children}</>;
};
